import { StoryblokComponent, storyblokEditable } from "@storyblok/react"

export default function PageRenderer({ blok }: any) {
  return (
    <main {...storyblokEditable(blok)}>
      {blok.body?.map((nestedBlok: any) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
    </main>
  )
}
